import {
    Flex,
    useStyles,
    Label,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { LogoInCircle } from '@archipro-design/icons';

import * as S from './DirectoryHeader.style';

interface HeroTitleProp {
    title: string;
    showIcon?: boolean;
}

const HeroTitle: React.FC<HeroTitleProp> = ({ title, showIcon }) => {
    const { css } = useStyles();
    const { mobile: isMobile } = useAppDisplayModeContext();

    return (
        <Flex vAlign="start">
            <Label
                as="h1"
                className={css(S.HeroTitle)}
                variables={{
                    fontSize: pxToRem(isMobile ? 72 : 120),
                    lineHeight: pxToRem(isMobile ? 80 : 115),
                    letterSpacing: isMobile ? `-0.015em` : '-0.01em',
                }}
            >
                {title}
            </Label>
            {showIcon && (
                <Flex
                    vAlign="center"
                    hAlign="center"
                    className={css(S.HeroTitleCopyright)}
                >
                    <LogoInCircle
                        variables={{
                            '1xSize': pxToRem(isMobile ? 9.1 : 18.56),
                        }}
                    />
                </Flex>
            )}
        </Flex>
    );
};

export default HeroTitle;
